module.exports = __webpack_public_path__ + "static/petit-bain-5-a219e500e26a3a07dc971132c9c77280.png";